import { useContext } from "react";

import { WhitelabelContext } from "@/providers/whitelabel-provider";

export function useWhitelabel() {
  const context = useContext(WhitelabelContext);

  if (!context) {
    throw new Error("useWhitelabel must be used within a WhitelabelProvider");
  }

  return context;
}
